import { render, staticRenderFns } from "./LbaContentTabs.vue?vue&type=template&id=54834870"
import script from "./LbaContentTabs.vue?vue&type=script&lang=js"
export * from "./LbaContentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports